var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"outline block rounded"},[_vm._t("default"),_vm._v(" "),(_vm.blok.text)?_c('FormLabel',{attrs:{"blok":_vm.blok}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }